import { useEffect, useRef, useState } from 'react';
import { UnicodeEntity } from '@mews/enums';
import { ClickAwayProps, withClickAway } from '@optimus-web/helpers';
import { ExpandIcon } from '../ExpandIcon';
import StepBar, { StepBarProps } from './StepBar';
import { OpenableVerticalStepperContainer, StepCountElement, ToggleButtonElement } from './style';

type OpenableVerticalStepBarProps = StepBarProps & ClickAwayProps;

const OpenableVerticalStepBar = ({
    steps,
    activeStep,
    onStepChange,
    registerClickAway,
    deregisterClickAway,
    ...other
}: OpenableVerticalStepBarProps) => {
    const [isOpened, setIsOpened] = useState(false);

    const containerRef = useRef(null);

    useEffect(
        () => () => {
            deregisterClickAway();
        },
        [deregisterClickAway]
    );

    const handleClose = () => {
        setIsOpened(false);

        deregisterClickAway();
    };

    const handleOpen = () => {
        setIsOpened(true);

        registerClickAway({
            handler: handleClose,
            roots: [containerRef.current],
        });
    };

    const handleStepChange = (value: string) => {
        setIsOpened(false);

        if (onStepChange) {
            onStepChange(value);
        }
    };

    const activeItemIndex = steps.findIndex((item) => item.value === activeStep);
    const newSteps = isOpened
        ? steps
        : steps.map((item, index) => ({ ...item, order: index })).filter((item) => item.value === activeStep);

    return (
        <OpenableVerticalStepperContainer ref={containerRef}>
            <ToggleButtonElement
                type="button"
                onClick={isOpened ? handleClose : handleOpen}
                small={steps[activeItemIndex] ? !steps[activeItemIndex].secondaryText : true}
            >
                {!isOpened ? (
                    <StepCountElement>
                        {activeItemIndex + 1}
                        {UnicodeEntity.ForwardSlash}
                        {steps.length}
                    </StepCountElement>
                ) : null}
                <ExpandIcon expanded={isOpened} />
            </ToggleButtonElement>
            <StepBar
                {...other}
                activeStep={activeStep}
                vertical
                steps={newSteps}
                onStepChange={handleStepChange}
                small
            />
        </OpenableVerticalStepperContainer>
    );
};

export default withClickAway(OpenableVerticalStepBar);
